<template>
  <nav class="navbar navbar-expand-lg navbar-light f-navbar f-container fixed-top">
    <a class="navbar-brand app-logo" href="/">
      <img src="../assets/img/logo.png" class="img-fluid align-self-center pr-1" alt="logo" />
      <span class="f-theme-color mt-0 mb-0">Fasdo</span>
    </a>
    <button
      class="navbar-toggler float-right toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <img src="../assets/img/icons/hamburger.svg" class="img-fluid" />
    </button>

    <div class="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
      <ul class="navbar-nav">
        <li class="nav-item" data-toggle="collapse" data-target="#navbarSupportedContent">
          <router-link to="/" class="nav-link" active-class="active" exact>
            <span>Home</span>
          </router-link>
        </li>
        <li class="nav-item" data-toggle="collapse" data-target="#navbarSupportedContent">
          <router-link to="/contact" class="nav-link" active-class="active" exact>
            <span>Contact Us</span>
          </router-link>
        </li>
        <li class="nav-item" data-toggle="collapse" data-target="#navbarSupportedContent">
          <router-link to="/faq" class="nav-link" active-class="active" exact>
            <span>FAQ's</span>
          </router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: "Navbar"
};
</script>

<style scoped>
.f-navbar {
  padding-bottom: 0;
  background: #ffffff;
  -webkit-box-shadow: 0 3px 6px -6px rgb(0, 0, 0, 0.05);
  -moz-box-shadow: 0 3px 6px -6px rgb(0, 0, 0, 0.05);
  box-shadow: 0 3px 6px -6px rgb(0, 0, 0, 0.35);
}

.app-logo img {
  width: 3em;
}

.toggler {
  outline: 0;
  border: 0;
}

.app-logo span {
  font-weight: 800;
  font-size: large;
  text-transform: uppercase;
}

#navbarSupportedContent ul {
  padding-right: 5em;
}

#navbarSupportedContent ul li {
  display: block;
  position: relative;
}

#navbarSupportedContent ul li a {
  font-size: medium;
  text-transform: uppercase;
  padding: 14px 16px;
  padding-bottom: 1.375em;
  margin: 0px 16px;
}

#navbarSupportedContent ul li > .active,
a[aria-expanded="true"] {
  color: #ee5214;
  border-bottom: 5px solid #ee5214;
}

.toggler img {
  width: 1.5em;
}

@media only screen and (max-width: 600px) {
  #navbarSupportedContent ul li a {
    font-size: medium;
    padding: 14px 16px;
    padding-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue